import { PaymentMethodCode } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

export const MODAL_NAMES = {
  GIFT_CARDS_FAQ: 'GIFT_CARDS_FAQ',
}
export const GIFT_CARDS_PAYMENT_METHOD = [
  PaymentMethodCode.CARD,
  PaymentMethodCode.GOOGLE_PAY,
  PaymentMethodCode.APPLE_PAY,
]
